module.exports = __webpack_public_path__ + "img/bus_nosignal.9c31d9af.svg";